import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
class CouponAdd extends React.Component {
  state = {
    coupon_code: '',
    coupon_desc: '',
    coupon_amount: '',
    coupon_start_date: '',
    coupon_end_date: '',
    amount_type: 'DECIMAL',
    is_active: true,
    is_online: true,
    number_of_user_use: '',
    coupon_applied: [],
    Products_data: [],
    user_allow_to_use: 'MULTIPLE',
    coupon_for: 'CRUISE',
    booking_start_date: '',
    booking_end_date: '',
    isData: false,
    EventCompanyList: [],
    categoryList: [],
    cruiseCat: [
      {
        id: 'T',
        name: 'Trips',
      },
    ],
    eventCat: [
      {
        id: 'O',
        name: 'Offers',
      },
      {
        id: 'A',
        name: 'Activities',
      },
    ],
  }

  componentDidMount() {
    this.CouponLists()
    this.CruiseList()
    this.EventCompanyList()
    this.setState({
      categoryList: this.state.cruiseCat,
    })
  }

  handleChange = (event) => {
    if (event.target.name === 'coupon_applied') {
      if (this.state.coupon_applied?.includes(event.target.value)) {
        const updatedCoupons = (this.state.coupon_applied || []).filter((item) => item !== event.target.value)

        this.setState({
          [event.target.name]: updatedCoupons,
        })
      } else this.setState({ [event.target.name]: [...this.state.coupon_applied, event.target.value] })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
    if (event.target.name === 'coupon_for') {
      if (event.target.value === 'EVENT') {
        this.setState({
          categoryList: this.state.eventCat,
        })
      } else if (event.target.value === 'CRUISE') {
        this.setState({
          categoryList: this.state.cruiseCat,
        })
      }
    }
  }

  EventCompanyList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/event-companies/list-event-companies/ALL`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            EventCompanyList: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  CouponLists = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-coupons', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.coupon_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            if (itm.coupon_for === 'CRUISE') {
              this.setState({
                categoryList: this.state.cruiseCat,
              })
            } else if (itm.coupon_for === 'EVENT') {
              this.setState({
                categoryList: this.state.eventCat,
              })
            }
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addCoupon = () => {
    var dateDMY = moment(this.state.coupon_start_date).format('MM/DD/YYYY')
    var dateDMY1 = moment(this.state.coupon_end_date).format('MM/DD/YYYY')

    var data = {
      coupon_code: this.state.coupon_code,
      coupon_desc: this.state.coupon_desc,
      coupon_for: this.state.coupon_for,
      coupon_amount: this.state.coupon_amount,
      coupon_start_date: dateDMY,
      amount_type: this.state.amount_type,
      coupon_end_date: dateDMY1,
      is_active: this.state.is_active,
      is_online: this.state.is_online,
      number_of_user_use: this.state.number_of_user_use,
      coupon_applied_to_boats: this.state.coupon_applied,
      user_allow_to_use: this.state.user_allow_to_use,
      booking_end_date: this.state.booking_end_date,
      booking_start_date: this.state.booking_start_date,
    }

    this.setState({ isData: true })
    if (this.props.coupon_id) {
      data = {
        ...data,
        id: this.props.coupon_id,
      }
      axios
        .put(Constant.getAPI() + '/admin/edit-coupon', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Coupon Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/coupon-controller`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/admin/add-coupon', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Coupon Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/coupon-controller`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  CruiseList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveData = () => {
    var that = this
    if (that.state.amount_type === 'PERCENTAGE' && parseInt(that.state.coupon_amount) >= 101) {
      Swal.fire({
        title: 'Percentage Amount exceeded',
        icon: 'error',
        text: 'Percentage will be 1 - 100',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    that.addCoupon()
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Coupon Code</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="coupon_code"
                    placeholder="coupon code"
                    onChange={this.handleChange}
                    value={this.state.coupon_code}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Coupon Amount Type</label>
                <div className="col-sm-9">
                  <select
                    name="amount_type"
                    className="form-control"
                    value={this.state.amount_type}
                    onChange={this.handleChange}
                  >
                    <option value="DECIMAL">Decimal</option>
                    <option value="PERCENTAGE"> Percentage </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">User allow to use</label>
                <div className="col-sm-9">
                  <select
                    name="user_allow_to_use"
                    className="form-control"
                    value={this.state.user_allow_to_use}
                    onChange={this.handleChange}
                  >
                    <option value="MULTIPLE">Multiple</option>
                    <option value="ONETIME"> Onetime </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Coupon For</label>
                <div className="col-sm-9">
                  <select
                    name="coupon_for"
                    className="form-control"
                    value={this.state.coupon_for}
                    onChange={this.handleChange}
                  >
                    <option value="CRUISE">CRUISE</option>
                    <option value="EVENT"> EVENT </option>
                  </select>
                </div>
              </div>
            </div>
            {this.state.coupon_for === 'CRUISE' ? (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Boats</label>
                  <div className="col-sm-9">
                    <select
                      name="coupon_applied"
                      className="form-control"
                      multiple
                      onChange={this.handleChange}
                      value={this.state.coupon_applied}
                    >
                      <option>Select boats</option>
                      {this.state?.Products_data?.length > 0
                        ? this.state.Products_data.map((itm) => (
                            <option
                              value={itm.id}
                              key={itm.id}
                            >
                              {itm.cruise_name_en}
                              {'/ '}
                              {itm.cruise_name_ar}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Event Company</label>
                  <div className="col-sm-9">
                    <select
                      name="coupon_applied"
                      className="form-control"
                      multiple
                      onChange={this.handleChange}
                      value={this.state.coupon_applied}
                    >
                      <option>Select Event Company</option>
                      {this.state?.EventCompanyList?.length > 0
                        ? this.state.EventCompanyList.map((itm) => (
                            <option
                              value={itm.id}
                              key={itm.id}
                            >
                              {itm.company_short_name_en}
                              {'/ '}
                              {itm.company_short_name_ar}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Number of user use</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="number_of_user_use"
                    placeholder="Number of user use"
                    onChange={this.handleChange}
                    value={this.state.number_of_user_use}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Coupon Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="coupon_amount"
                    placeholder="coupon amount"
                    onChange={this.handleChange}
                    value={this.state.coupon_amount}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    id="start_date"
                    name="coupon_start_date"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.coupon_start_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    id="end_date"
                    name="coupon_end_date"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.coupon_end_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Online </label>
                <div className="col-sm-9">
                  <select
                    name="is_online"
                    className="form-control"
                    value={this.state.is_online}
                    onChange={this.handleChange}
                  >
                    <option value="true">Online</option>
                    <option value="false"> Ofline </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Booking Start Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    id="booking_start_date"
                    name="booking_start_date"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.booking_start_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Booking End Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    id="booking_end_date"
                    name="booking_end_date"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.booking_end_date}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false"> InActive </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description</label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="coupon_desc"
                    placeholder="coupon desc"
                    onChange={this.handleChange}
                    value={this.state.coupon_desc}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/coupon-controller`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CouponAdd
